export const findClosestValue = (
	input?: number | string,
	items?: number[],
): string => {
	const numberInput = Number(input);

	if (!items?.length || !Number.isFinite(numberInput)) return "";

	return String(
		items.reduce((prev, curr) =>
			Math.abs(curr - numberInput) < Math.abs(prev - numberInput) ? curr : prev,
		),
	);
};
